import React from "react";
import { useTranslation } from "react-i18next";
import { cx } from "@digitalisation/enlixy-comp";
import { contextText, describeContext } from "../../../hooks/useCockpitContext";
import { useSAPDataStore } from "../../../store/SAPDataStore";

const DOT = {
  machine: "bg-blue-500",
  line: "bg-emerald-500",
  general: "bg-gray-400",
} as const;

/** "Maschine: 20055", "Linie: …" or "Alle Daten", with the cockpit's colour dot. */
export const ContextLabel: React.FC<{ contextId?: string }> = ({
  contextId,
}) => {
  const { t } = useTranslation();
  const machines = useSAPDataStore((s) => s.machines);
  const lines = useSAPDataStore((s) => s.lines);
  const context = describeContext(contextId, machines, lines);

  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        aria-hidden="true"
        className={cx("h-1.5 w-1.5 shrink-0 rounded-full", DOT[context.scope])}
      />
      {contextText(context, (key, fallback) => t(key, fallback))}
    </span>
  );
};
